import { render, staticRenderFns } from "./FansFollowList.vue?vue&type=template&id=2b3f52c2&scoped=true&"
import script from "./FansFollowList.vue?vue&type=script&lang=js&"
export * from "./FansFollowList.vue?vue&type=script&lang=js&"
import style0 from "./FansFollowList.vue?vue&type=style&index=0&id=2b3f52c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3f52c2",
  null
  
)

export default component.exports